import AddendumSignType from './AddendumSignType';

const AddendumType = {
    ...AddendumSignType,
    PL01: [0, 'PL01'],
}

export default AddendumType;
